<template>
  <section class="section looking-for-section-container">
    <div class="looking-for-section-wrapper">
      <h2 class="header-title looking-for-header-title">Are you looking for:</h2>

      <div class="looking-for-content-container">
        <BaseCard
          v-for="(profile, index) in cards"
          :key="profile.name"
          :profile="profile"
          :class="['feature-card', `card-${index + 1}`]"
          show-noise
        >
          <div class="feature-content-container">
            <h5 class="feature-title">{{ profile.title }}</h5>
            <h6 class="feature-desc">{{ profile.description }}</h6>
          </div>
          <img v-if="profile.image" :src="profile.image" alt="Feature Image" class="feature-image" />
        </BaseCard>
      </div>

      <h5 class="header-title looking-for-footer-title">
        If so, then joining our talent roster is a no-brainer.
      </h5>
    </div>
  </section>
</template>

<script setup>
import BaseCard from "@/components/common/BaseCard.vue";

const cards = [
  {
    title: "Remote work opportunities",
    description: "with progressive companies",
    image: require("@/assets/images/feature-image-1.png")
  },
  {
    title: "Individual contributor roles",
    description: "that match your expertise",
    image: require("@/assets/images/feature-image-2.png")
  },
  {
    title: "A place on an international team",
    description: "of like-minded professionals",
  },
  {
    title: "Work at a sustainable pace",
    description: "with respect for work-life balance",
  },
  {
    title: "Work on meaningful projects",
    description: "with opportunities to use modern technologies",
  }
];
</script>

<style lang="scss" scoped>
.looking-for-section-container {
  max-width: unset;
  margin: 0;
  background-color: #FAFAFA;
}

.looking-for-section-wrapper {
  max-width: 1120px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media screen and (max-width: 1120px) {
    margin: 0 16px;
  }

  .looking-for-header-title {
    font-size: 40px;
    line-height: 52px;
    text-align: center;
  }

  .looking-for-footer-title {
    font-weight: 500;
    text-align: center;
  }

  .looking-for-content-container {
    display: grid;
    grid-template-rows: minmax(324px, auto) minmax(220px, auto);
    grid-template-areas:
      "card-1 card-1 card-1 card-2 card-2 card-2"
      "card-3 card-3 card-4 card-4 card-5 card-5";
    gap: 20px;

    @media screen and (max-width: 768px) {
      grid-template-rows: repeat(5, minmax(220px, auto));
      grid-template-areas:
        "card-1"
        "card-2"
        "card-3"
        "card-4"
        "card-5";
    }

    .card-1 {
      grid-area: card-1;
      background-color: #2F7879;

      .feature-title {
        color: #F9D9B0;
      }

      .feature-desc {
        color: #FFFFFF;
      }

      &:after {
        background-image: url('@/assets/images/noise-bg-card-1.png');
        background-position: right top;
        background-size: contain;
        opacity: 1;
      }
    }

    .card-2 {
      grid-area: card-2;
      background-color: #CF5513;

      .feature-title {
        color: #F9D9B0;
      }

      .feature-desc {
        color: #FFFFFF;
      }

      &:after {
        background-image: url('@/assets/images/noise-bg-card-2.png');
        background-position: right top;
        background-size: contain;
        opacity: 0.5;
      }
    }

    .card-3 {
      grid-area: card-3;
      background-color: #F68C1E;

      .feature-title {
        color: #141414;
      }

      .feature-desc {
        color: #FAFAFA;
      }

      &:after {
        background-image: url('@/assets/images/noise-bg-card-3.png');
        background-position: right top;
        background-size: 25%;
        opacity: 1;
      }
    }

    .card-4 {
      grid-area: card-4;
      background-color: #7FC9C5;

      .feature-title {
        color: #141414;
      }

      .feature-desc {
        color: #2F7879;
      }

      &:after {
        background-image: url('@/assets/images/noise-bg-card-4.png');
        background-position: right bottom -24px;
        background-size: 25%;
        opacity: 1;
      }
    }

    .card-5 {
      grid-area: card-5;
      background-color: #EEE7DD;

      .feature-title {
        color: #141414;
      }

      .feature-desc {
        color: #141414;
      }

      &:after {
        background-image: url('@/assets/images/noise-bg-card-5.png');
        background-position: right top;
        background-size: 50%;
        opacity: 0.75;
      }
    }

    .feature-card {
      display: flex;
      flex-direction: row;
      gap: 20px;
      padding: 32px;

      @media screen and (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        padding: 32px 16px;
      }

      .feature-content-container {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }

      .feature-title,
      .feature-desc {
        text-align: left;

        @media screen and (max-width: 768px) {
          text-align: center;
        }
      }

      .feature-title {
        font-weight: 600;
        font-size: 28px;
      }

      .feature-desc {
        font-weight: 300;
        font-size: 24px;
      }

      .feature-image {
        width: 260px;
        height: 260px;
        z-index: 2;
      }
    }
  }
}
</style>
